import { StateService } from '@uirouter/angular';
import { Injectable } from '@angular/core';
import * as _ from 'lodash';
import { GfTranslateService } from '../../../core/services/core.translate.service';
import { UserService } from '../../../core/services/core.user.service';
import { UserRest } from '../../../core/services/core.user.rest.service';
import { TrackerRest } from './tracker.rest';
import { TrackerService } from './tracker.service';
import { TrackeritemRest } from './trackeritem.rest';
import { marker } from '../../../core/services/ngx-translate-extract-marker';

@Injectable()
export class TrackerFilterService {

	private _tracker:any = {};
	private assigneeFieldOptions = {none: true, any: true, current_user: true, any_user: true};

    constructor(
		private window: Window,
		private trackeritemRest: TrackeritemRest, 
		private userRest: UserRest, 
		private translateService: GfTranslateService, 
		private trackerService: TrackerService,
		private trackerRest: TrackerRest, 
		private userService: UserService, 
		private stateService: StateService) {
	}

	// START PRIVATE METHODS
	private getFilteredAssignees(q) {
		return new Promise((resolve, reject) => {
			this.trackerRest.assignees(_.get(this.stateService.params, 'tracker', 0), q)
			.then((result) => {
					var elements = this.addOptionalFieldElements(
						this.getAssigneeFilterElements(_.get(result, 'items', [])),
						this.assigneeFieldOptions
					);
					resolve(elements);
				}, () => {
					resolve(
						this.addOptionalFieldElements(
							this.getAssigneeFilterElements([]),
							this.assigneeFieldOptions
						)
					);
				}
			);
		});

	}

	private bracketWrap(str, s = null, f = null) {
		return (s || '[') + 
			this.translateService.translate(str) +
		(f || ']');
	}

	private parenWrap(str) {
		return this.bracketWrap(str, '(', ')');
	}

	private addOptionalFieldElements(fieldElements, options) {
		//status related options
		if (options.any_closed_status) this._addOption(fieldElements, '-4', '-4', this.bracketWrap(marker('Any Closed Status')));
		if (options.any_open_status) this._addOption(fieldElements, '-3', '-3', this.bracketWrap(marker('Any Open Status')));

		//user related options
		if (options.current_user) this._addOption(fieldElements, '-1', '-1', this.bracketWrap(marker('Current User')));
		if (options.any_user) this._addOption(fieldElements, '-2', '-2', this.bracketWrap(marker('Any User')));

		//generic extra options
		if (options.none) this._addOption(fieldElements, 100, '100', this.parenWrap(marker('None')));
		if (options.any) this._addOption(fieldElements, 0, '',this.parenWrap(marker('Any')));

		return fieldElements;
	}

	private _addOption(arrOptions, id, strValue, strLabel) {
		var _option = {
			id: id,
			value: strValue,
			label: strLabel
		};

		if (Array.isArray(arrOptions)) {
				arrOptions.unshift(_option);
		}
	}


	private convertAssignees(assignees) {
		var _convertedAssignees = [];

		_.each(assignees, (assignee) => {
			var _assignee = {
				id: assignee.id,
				value: assignee.id,
				label: assignee.firstname + ' ' + assignee.lastname
			};

		_convertedAssignees.push(_assignee);
		});

		return _convertedAssignees;
	}

	private addAnyNoneOptions(filter) {
		if (!Array.isArray(filter.fieldElements)) {
			filter.fieldElements = [];
		}

		this.addOption(filter.fieldElements, 100, '100', this.translateService.translate('None'));
		this.addOption(filter.fieldElements, 0, '', this.translateService.translate('Any'));

		//Set default value as "Any"
		filter.value = filter.fieldElements[0];
	}

	private addOption(arrOptions, id, strValue, strLabel) {
		var _option = {
			id: id,
			value: strValue,
			label: strLabel
		};

		if (Array.isArray(arrOptions)) {
			arrOptions.unshift(_option);
		}
	}

	private setFilterParams(filters) {
		var _defaults = {
			sort_field :'id',
			sort_dir: 'asc',
			page_num: 1,
			page_size: 20,
			tracker: 0,
			forceReload: false
		};

		const params = new URLSearchParams(this.window.location.search);
		var _params = _.cloneDeep(_.defaults(params, _defaults));

		_.each(filters, (filter) => {
			if (_.isObject(filter.value)) {
				if (_.has(filter.value, 'id') && filter.value.id != '') {
					_params[filter.alias] = _.get(filter, 'value.value', filter.value.id);
				} else {
					delete _params[filter.alias];
				}
			} else {
				if (filter.value != "") {
					_params[filter.alias] = filter.value;
				} else {
					delete _params[filter.alias];
				}
			}
		});

		return _params;
	}

	private getAttachmentFilterOptions() {
		return [
			{
				id: 0,
				value: '',
				label: this.parenWrap(this.translateService.translate('Any'))
			},
			{
				id: 1,
				value: '1',
				label: this.translateService.translate('Yes')
			},
			{
				id: 2,
				value: '2',
				label: this.translateService.translate('No')
			},
		];
	}

	public getParentChildRelationshipOptions() {
		return [
			{
				id: 0,
				value: '',
				label: this.parenWrap(this.translateService.translate('Any'))
			},
			{
				id: 1,
				value: '1',
				label: this.translateService.translate('Has Parent')
			},
			{
				id: 2,
				value: '2',
				label: this.translateService.translate('Has Child')
			},
			{
				id: 3,
				value: '3',
				label: this.translateService.translate('Has Parent or Child')
			},
		];
	}

	private getStoryPointsOptions() {
		return _.concat(
			{
				id: 0,
				value: '',
				label: this.parenWrap(this.translateService.translate('Any'))
			},
			this.trackerService.fields.builtIn.story_points.getStoryPointsOptionsList(_.get(this._tracker, 'fields.storyPoints.fieldElements', []))
		);
	}

	private setStoryPointsFilterOptions(filters) {
		var _storyPointsFilter: any = _.find(filters, {alias: 'storyPoints'});
		if (_storyPointsFilter) {
			_storyPointsFilter.fieldElements = this.getStoryPointsOptions();
			_storyPointsFilter.value = _storyPointsFilter.fieldElements[0];
		}
	}

	private _getFilters(params) {
		var _filters = [], _filter;

		if (!_.isObject(this._tracker) || !_.has(this._tracker, 'fields')) {
			return _filters;
		}

		_filters.push( {alias: '_textsearch', fieldName: this.translateService.translate("Text search"), value: '', fieldType: 24, isExtraField: false} );
		_filters.push( {alias: 'id', fieldName: "ID", value: '', fieldType: 4, isExtraField: false} );
		_filters.push( {alias: 'summary', fieldName: this.translateService.translate("Summary"), value: '', fieldType: 20, isExtraField: false} );
		
		var _assignee = {alias: 'assignees', fieldName: this.translateService.translate("Assignee"), value: '', fieldType: 1, fieldElements: params.assignees, isExtraField: false};
		this.addOption(_assignee.fieldElements, '-1', '-1', 'Current User');
		this.addOption(_assignee.fieldElements, '-2', '-2', 'Any User');
		this.addAnyNoneOptions(_assignee);
		_filters.push( _assignee  );

		_filters.push( {alias: 'submittedBy', fieldName: this.translateService.translate("Submitted By"), value: '', fieldType: 22, isExtraField: false} );	
		_filters.push( {alias: 'attachments', fieldName: this.translateService.translate("Attachments"), value: '', fieldElements: this.getAttachmentFilterOptions(), fieldType: 25, isExtraField: false} );
		_filters.push({ alias: 'parentChildRelationship', fieldName: this.translateService.translate("Has Parent/Child"), value: '', fieldElements: this.getParentChildRelationshipOptions(), fieldType: 26, isExtraField: false });

		_.each(_.get(this._tracker, 'fields', []), (field, fieldAlias) => {
			if (field.isEnabled) {
				_filter = _.cloneDeep(field);

				if (!_filter.isExtraField || _filter.alias == 'status') {
					_filter.value = '';

					switch(_filter.alias) {
						case 'priority':
							_filter.fieldElements = this.trackerService.fields.builtIn.priority.getList();
							_filter.fieldType = 1;
							this.addAnyNoneOptions(_filter);
							break;

						case 'status':
							_filter.fieldElements = _.cloneDeep(this._tracker.fields.status.fieldElements);
							this.addOption(_filter.fieldElements, '-4', '-4', this.translateService.translate('Any closed status'));
							this.addOption(_filter.fieldElements, '-3', '-3', this.translateService.translate('Any open status'));
							this.addAnyNoneOptions(_filter);
							break;

						case 'waitingFor':
							_filter.fieldElements = this.trackerService.fields.builtIn.waiting_for.getList();
							_filter.fieldType = 1;
							this.addAnyNoneOptions(_filter);
							break;

						case 'sprint':
							_filter.fieldElements = _.cloneDeep(this._tracker.fields.sprint.fieldElements);
							this.addAnyNoneOptions(_filter);
							break;

						case 'lockStatus':
							_filter.fieldElements = this.trackerService.fields.builtIn.lock_status.getList();
							this.addAnyNoneOptions(_filter);
							break;

						case 'attachments':
							_filter.value = _filter.fieldElements[0];
							break;

						case 'parentChildRelationship':
							_filter.value = _filter.fieldElements[0];
							break;

						case 'storyPoints':
							_filter.fieldElements = this.trackerService.fields.builtIn.story_points.getStoryPointsOptionsList(_.get(this._tracker, 'fields.storyPoints.fieldElements', []));
							this.addAnyNoneOptions(_filter);
							break;
					}

					_filters.push(_filter);
				} else {
					//If it' a status/select/multiselect/radio/checkbox/members/release type, then add the "any" and "none" options
					if ([1,8,3,2,5,12,7].includes(_filter.fieldType)) {
						this.addAnyNoneOptions(_filter);
					} else if (_filter.fieldType == 9) {
						//Do Nothing
					} else {
						_filter.value = '';
					}
					_filters.push(_filter);
				}
			}
		});

		//Group filters by type
		var _groupedFilters = {
			'main_fields':  _filters.filter((item) => item.isExtraField === false),
			'extra_fields': _filters.filter((item) => item.isExtraField === true)
		};

		return _groupedFilters;
	}


	private restoreSelections(filters, params) {
		var _element,
			_groupedFilters = _.union(filters.main_fields, filters.extra_fields);
		
		_.each(params, (pValue, pKey) => {
			let _filter: any;
			_filter = _.find(_groupedFilters, {alias: pKey});
			if (typeof _filter === 'object') {
				//If it' a status/select/multiselect/radio/checkbox/members/release type, then add the "any" and "none" options
				if ([1,8,3,2,5,12, 7].includes(parseInt(_.get(_filter, 'fieldType', ''))) || _.get(_filter, 'alias', '') == 'assignee') {
					_element = _.find(_.get(_filter, 'fieldElements', []), (item) => {
						if (item.id == pValue) {
							return true;
						}
						return false;
					});
					if (_.isObject(_element)) {
						_filter.value = _element;
					}
				} else {
					_filter.value = pValue;
				}
			}
		});
	}

	/**
	 * Given a list of assignees, retrieves an assignees filter array
	 * @param {Array} of assignee objects
	 * @returns {Array} of assignee filter objects
	 */
	private getAssigneeFilterElements(assignees) {
		return _.map(assignees, (assignee) => {
			return {
				id: assignee.id,
				value: assignee.id,
				label: assignee.firstname + ' ' + assignee.lastname
			};
		});
	}
	// END PRIVATE METHODS
		
	// START PUBLIC METHODS
 
	/**
	 * Given a set of filters and an alias, looks up for the filter and sets up the extra options
	 * @param {array} filters
	 * @param {object} options (can be: none, any, current_user, any_user, any_open_status, any_closed_status)
	 */
	public addOptionsToFilter(filters, alias, options, extraElements = null) {
		var filter = _.find(filters, {alias: alias});

		if (!filter) {
			return
		};

		if (!Array.isArray(filter.fieldElements)) {
			filter.fieldElements = [];
		}

		this.addOptionalFieldElements(filter.fieldElements, options);

		if (!_.isEmpty(extraElements) && Array.isArray(extraElements)) {
			filter.fieldElements = _.union(filter.fieldElements, extraElements);
		}

		//Set default value as "Any"
		filter.value = filter.fieldElements[0];
	}

	/**
	 * Given a list of main field filters, finds the sprint field filter and sets 
	 * up the values in an organized form (grouping by sprint status)
	 * @param {array} of filters
	 */
	public setSpecialElementsGroupingOnSprints(filters) {
		var filter = _.find(filters, {alias: 'sprint'});

		if (!filter) {
			return
		};

		filter.fieldElements = this.trackerService.fields.getSprintsGroupedByStatus(filter);
	}

	/**
	 * Given a list of main field filters, sets up extra options and values
	 * @param {array} of filters
	 * @returns {array} of filters
	 */
	public setupMainFilters(filters, tracker) {
		this._tracker = _.cloneDeep(tracker);
		//Add custom Filters
		var ret = [
			{ alias: '_textsearch', fieldName: this.translateService.translate("Text search"), value: '', fieldType: 24, isExtraField: false },
			{ alias: 'id', fieldName: "ID", value: '', fieldType: 4, isExtraField: false },
			{ alias: 'summary', fieldName: this.translateService.translate("Summary"), value: '', fieldType: 20, isExtraField: false },
			{ alias: 'submittedBy', fieldName: this.translateService.translate("Submitted By"), value: '', fieldType: 22, isExtraField: false },
			{ alias: 'assignees', 
				fieldName: this.translateService.translate("Assignee"), 
				value: '', fieldType: 1,
				fieldElements: this.getAssigneeFilterElements(tracker.rel.assignees), 
				search: this.getFilteredAssignees,
				isExtraField: false
			},
			{ alias: 'attachments', fieldName: this.translateService.translate("Attachments"), value: '', fieldType: 25, isExtraField: false },
			{ alias: 'parentChildRelationship', fieldName: this.translateService.translate("Has Parent/Child"), value: '', fieldType: 26, isExtraField: false }
		].concat(filters);

		//set default value
		ret.map((filter) => { filter.value = ''});

		//Add special options to some filters
		this.addOptionsToFilter(ret, 'assignees', this.assigneeFieldOptions);
		this.addOptionsToFilter(ret, 'priority', {none: true, any: true}, []);
		this.addOptionsToFilter(ret, 'waitingFor', {none: true, any: true});
		this.addOptionsToFilter(ret, 'sprint', {none: true, any: true});
		this.addOptionsToFilter(ret, 'lockStatus', {any: true}, this.trackerService.fields.builtIn.lock_status.getList());
		this.addOptionsToFilter(ret, 'attachments', {}, this.getAttachmentFilterOptions());
		this.addOptionsToFilter(ret, 'parentChildRelationship', {}, this.getParentChildRelationshipOptions());
		this.setStoryPointsFilterOptions(filters);

		//Set special elements grouping for sprint
		this.setSpecialElementsGroupingOnSprints(ret);

		return ret;
	}

	/**
	 * Given a list of extra field filters, sets up extra options and values
	 * @param {array} of filters
	 * @returns {array} of filters
	 */
	public setupExtraFieldFilters(filters) {
		_.map( filters, (filter) => {
			filter.value = '';

			//If it' a status/select/multiselect/radio/checkbox/members/release type, then add the "any" and "none" options
			if ([1,8,3,2,5,12,25,26].includes(filter.fieldType)) {
				this.addOptionsToFilter(filters, filter.alias, {none: true, any: true});

				if (filter.fieldType == 8) {
					//Set special elements grouping for field of type release
					filter.fieldElements = this.trackerService.fields.getReleasesGroupedByStatus(filter);
				}
			} else if (filter.fieldType == 7) { //Type status
				this.addOptionsToFilter(filters, filter.alias, {none: true, any: true, any_open_status: true, any_closed_status: true});
			}
		});

		return filters;
	}

	/**
	 * Given a tracker, returns an array of filter objects, with a filter object
	 * for each tracker field that is enabled
	 * @param {object} tracker
	 * @returns {array} of filter objects
	 */
	public getFilters(tracker: any) {
		let filters:any = {};
		let trackerFields: any;

		if (!_.isObject(tracker) || !_.has(tracker, 'fields')) {
			return filters;
		}

		trackerFields = _.get(tracker, 'fields', {});

		var ret = _.partition( _.filter( _.forOwn( _.cloneDeep(trackerFields), function(item) { return item } ), function(item) { return item.isEnabled } ), function(item) { return !item.isExtraField });

		//Group filters by type
		return {
			'main_fields':  this.setupMainFilters(ret[0], tracker),
			'extra_fields': (ret.length > 1) ? this.setupExtraFieldFilters(ret[1]) : []
		};
	}

	/**
	 * Given a filter object, returns true if it's of type "text", false otherwise
	 * @param {object} filter
	 * @returns {boolean}
	 */
	public isTypeText(filter) {
		return [4,10,11,6,20,22,24].includes(filter.fieldType);
	}

	/**
	 * Given a filter object, returns true if it's of type "select", false otherwise
	 * @param {object} filter
	 * @returns {boolean}
	 */
	public isTypeSelect(filter) {
		return [1,7,8,3,2,5,12,25,26].includes(filter.fieldType);
	}

	/**
	 * Given a filter object, returns true if it's of type "data", false otherwise
	 * @param {object} filter
	 * @returns {boolean}
	 */
	public isTypeDate(filter) {
		return (filter.fieldType == 9) ? true : false;
	}

	public isSortedBy(field, direction) {
		if (_.get(this.stateService.params, 'sort_field', '') == field) {
			if (_.lowerCase(_.get(this.stateService.params, 'sort_dir', '')) == _.lowerCase(direction)) {
				return true;
			}
		}
		return false;
	}

	/**
	 * Given a set of filter, returns
	 *
	 * @param {array} of filter objects
	 * @returns {array} of pairs {key: value}
	 */
	public getFilterValues(filters) {
		var ret = [];
		_.forOwn(filters, (filters, filterType) => {
				ret = ret.concat(_.filter(filters, (filter) => {
						return ( (_.isObject(filter.value)) ? (filter.value.id !== 0 ? true : false) : (filter.value) ? true : false  );
				}).map((filter) => {
						var obj = {};
						if (filter.alias == 'lockStatus') {
							obj[filter.alias] = ( (_.isObject(filter.value)) ? (filter.value.id !== 0) ? filter.value.value : '' : (filter.value) ? filter.value : ''  );
						} else {
							obj[filter.alias] = ( (_.isObject(filter.value)) ? (filter.value.id !== 0) ? filter.value.id : '' : (filter.value) ? filter.value : ''  );
						}
						return obj;
				}));
		});

		return ret;
	}

	/**
	 * Applies query string parameters to the filters
	 *
	 * @param {array} of filter objects
	 * @param {array} of query string parameters
	 * @returns {array} of filter objects updated
	 */
	public setFilterValues(filters, params) {
		var _filters = _.concat(filters.main_fields, filters.extra_fields);

		_.forOwn(params, (value, key) => {
			var filter = _filters.find((item) => item.alias === key);
			
			if (filter) {
				if (!_.isEmpty(filter.fieldElements)) {
					var element = _.find(filter.fieldElements, (element) => {
						//if (element.value == parseInt(value) ||  element.value == value) {
						if ((filter.alias == 'lockStatus' && element.value == value) || (filter.alias != 'lockStatus' && element.id == value)) {
							return true;
						}
						return false;
					});

					if (element) {
						filter.value = element;
					}
				} else {
					filter.value = value;
				}

			}
		});

		return filters;
	}

	public setup(tracker) {
		this._tracker = tracker;
	}

	public get(params, trackerId) {
		var _assignees = [];

		return new Promise((resolve, reject) => {
			try {
				if (trackerId === undefined) {
					reject();
				} else {
					var _filters:any = [];
					this.trackerService.loadAssignees(trackerId)
					.then((data: any) => {
						_assignees = data.items;
					}, () => {})
					.then(() => {
						var _convertedAssignees = this.convertAssignees(_assignees);

						try {
							_filters = this._getFilters({assignees: _convertedAssignees});
							this.restoreSelections(_filters, params);
							resolve(_filters);
						}catch(err) {
							reject();
						}
					});
				}
			} catch(err) {
				reject();
			}
		});
	}

	public applyFilters(filters, trackerId) {
		var _params = this.setFilterParams(_.union(filters.main_fields, filters.extra_fields));
		_params.tracker = trackerId;
		return _params;
	}

	public performSearch(params) {
		var _params = _.clone(params);
		delete _params.query;

		return new Promise((resolve, reject) => {
			this.trackeritemRest.fetch(0, _params)
			.then((response: any) => {
				var _data = [];
				if (_.has(response, 'items')) {
					_data = response.items;
				} else {
					if (_.isObject(response) && !_.isEmpty(response)) {
						_data.push(response);
					}
				}
				resolve(_data);
			}, (response) => {
				reject(response);
			});
		})
	}

	public getSavedFilters(trackerId) {
		return new Promise((resolve, reject) => {
			this.userRest.getUserPreference(this.userService.session.getUnixName(), 'custom_query_' + trackerId)
			.then((response: any) => {
				if (!_.isEmpty(response) && _.has(response, 'preferenceValue')) {
					try {
						resolve(JSON.parse(response.preferenceValue));
					} catch(err) {
						reject();
					}
				} else {
					reject();
				}
			}, (err) => {
				reject();
			});
		});
	}

	// END PUBLIC METHODS
}
